"use strict";

document.addEventListener("DOMContentLoaded", () => {
    const listItems = document.querySelectorAll(".steps .list__item");

    if (listItems.length === 0) return;

    const observerOptions = {
        root: null,
        rootMargin: "0px 0px -50% 0px",
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("active");
            } else {
                const triggerLine = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight * 0.5;

                if (entry.boundingClientRect.top > triggerLine) {
                    entry.target.classList.remove("active");
                }
            }
        });
    }, observerOptions);

    listItems.forEach((item) => observer.observe(item));
});